import { FC } from "react";
import { useApp } from "../context/useApp";
import { Product } from "../types";
import { Fieldset } from "../parts/inputs/Fieldset";
import { _, getAllProducts } from "../utils/helpers";
import { ImgSlider } from "../parts/slider";
import { metrics, PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX, SCREEN_BREAKPOINT_2, SLIDER_IMAGES } from "../utils/symbols";
import { ProductsQtySelector } from "../parts/inputs/ProductsQtySelector";

export const ProductsSelection: FC = () => {
    
    const {
        state: { booking, products, screen },
    } = useApp()
    
    const filteredProducts = getAllProducts(products)
        .sort((a, b) => {
            const a_isLimitedToPax = PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX.includes(a.id)
            const b_isLimitedToPax = PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX.includes(b.id)

            if (a_isLimitedToPax && !b_isLimitedToPax) return 1
            if (b_isLimitedToPax && !a_isLimitedToPax) return -1

            return 0
        })

    const handleProductQtyChange = (product: Product, newQty:number) => {
        const productQtyInBooking = booking.getProductQty(product.id)

        if (productQtyInBooking > newQty) booking.handleProduct('remove', product).render()
        if (productQtyInBooking < newQty) booking.handleProduct('add', product).render()
    }


    return (
        <Fieldset id="products-selection" FieldsetLabel={_('4co_compl__')} className="mt-7">
            {/* FOOD & DRINKS */}
            {screen.width > SCREEN_BREAKPOINT_2 && (<ImgSlider imgs={SLIDER_IMAGES} className="mt-10" aria-hidden/>)}
            <ProductsQtySelector 
                autoSelectFirstButton
                onProductQtyChange={handleProductQtyChange}
                products={filteredProducts}
            />
        </Fieldset>
    )
}

